import { E_Services } from '@repo-sapiens/constants';
import { EModelName } from './model-name';
import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';

export enum E_TransactionStatus {
  Initiated = 'initiated',
  InProgress = 'in_progress',
  Completed = 'completed',
  Failed = 'failed',
  Canceled = 'canceled',
  FailedWithRetry = 'failed_with_retry',
  UserCompleted = 'user_completed',
}

export enum E_TransactionType {
  Email = 'email',
  MeetingPrep = 'meeting_prep',
  MeetingSummary = 'meeting_summary',
  EmailDraft = 'email_draft',
  NewsPodcast = 'news_podcast',
  OverviewPodcast = 'overview_podcast',
  EventPodcast = 'event_podcast',
  ReportPodcast = 'report_podcast',
  ActionItem = 'action_item',
}

const TransactionSchema = new mongoose.Schema({
  user: {
    type: mongoose.Schema.Types.ObjectId,
    required: true,
    ref: EModelName.USER,
  },

  service: { type: String },

  serviceId: { type: String },

  creditCost: { type: Number },

  status: {
    type: String,
    default: E_TransactionStatus.Initiated,
  },

  comment: { type: String },

  refunded: { type: Boolean },

  metadata: {
    type: mongoose.Schema.Types.Mixed,
  },

  // Temporary data that might be needed during the transaction
  // and deleted after the transaction is completed
  temp: {
    type: mongoose.Schema.Types.Mixed,
    required: false,
  },

  endedAt: {
    type: Date,
  },

  stages: {
    type: [mongoose.Schema.Types.Mixed],
  },

  created: {
    type: Date,
    default: Date.now(),
  },
});

export type T_TransactionBase = InferSchemaType<typeof TransactionSchema>;

// Extend the type to provide proper typing for service and status
export interface T_Transaction
  extends Omit<
    T_TransactionBase,
    'service' | 'status' | 'metadata' | 'created' | 'endedAt' | 'stages'
  > {
  service: E_Services;
  status: E_TransactionStatus;
  metadata?: {
    serviceId?: string;
    calendarAttendee?: string;
    classification?: any;
    stateClassification?: any;
    meetingBot?: {
      botId: string;
      meetingId: string;
      transcriptId?: string;
      attendees: {
        email: string;
        name: string;
      }[];
    };
  };
  temp?: Record<string, unknown>;
  created?: Date;
  endedAt?: Date;
  stages?: {
    name: string;
    date: Date;
  }[];
}

export type T_TransactionDocument = T_Transaction &
  Document & {
    _id: string;
  };

export { TransactionSchema };
